"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PUBLIC_EMAIL_SEND = exports.PUBLIC_SUBMISSIONS_AGGREGATE = exports.PUBLIC_SUBMISSIONS_GET = exports.PUBLIC_SUBMISSIONS_PAGINATE = exports.PUBLISH_CONFIG = exports.GET_CONFIG = exports.CLIENT_FORM_SUBMIT = exports.CLIENT_FORM_UPLOAD_PHOTO = exports.SEO_UPDATE = exports.SEO_GET = exports.SUBMISSIONS_UPDATE_ORDER = exports.SUBMISSIONS_EDIT = exports.SUBMISSIONS_EXPORT = exports.SUBMISSIONS_PAGINATE = exports.ADMINS_PAGINATE = exports.ADMINS_DELETE = exports.ADMINS_UPDATE = exports.ADMINS_CREATE = exports.AUTH_SESSION_OUT = exports.AUTH_SESSION_IN = exports.AUTH_ADMIN = exports.ROOT = exports.API_HOST = void 0;
exports.API_HOST = process.env.ENV === 'local'
    ? "http://localhost:".concat(process.env.API_PORT)
    : "https://".concat(process.env.PROJECT_ID, ".firebaseapp.com");
// as const is a type assertion that tells TypeScript that the value of ROOT is a string literal type:
// so in hints it will show you the value of ROOT as `/api` instead of `string`
exports.ROOT = "/api";
// Admin:
exports.AUTH_ADMIN = "".concat(exports.ROOT, "/auth/admin");
exports.AUTH_SESSION_IN = "".concat(exports.ROOT, "/auth/session-in");
exports.AUTH_SESSION_OUT = "".concat(exports.ROOT, "/auth/session-out");
exports.ADMINS_CREATE = "".concat(exports.ROOT, "/admins/create");
exports.ADMINS_UPDATE = "".concat(exports.ROOT, "/admins/update/:id");
exports.ADMINS_DELETE = "".concat(exports.ROOT, "/admins/delete/:id");
exports.ADMINS_PAGINATE = "".concat(exports.ROOT, "/admins/paginate");
exports.SUBMISSIONS_PAGINATE = "".concat(exports.ROOT, "/submissions/paginate");
exports.SUBMISSIONS_EXPORT = "".concat(exports.ROOT, "/submissions/export");
exports.SUBMISSIONS_EDIT = "".concat(exports.ROOT, "/submissions/:id/edit");
exports.SUBMISSIONS_UPDATE_ORDER = "".concat(exports.ROOT, "/submissions/update-order");
exports.SEO_GET = "".concat(exports.ROOT, "/seo/get");
exports.SEO_UPDATE = "".concat(exports.ROOT, "/seo/update");
// Client Form:
exports.CLIENT_FORM_UPLOAD_PHOTO = "".concat(exports.ROOT, "/client-form/upload-photo");
exports.CLIENT_FORM_SUBMIT = "".concat(exports.ROOT, "/client-form/submit");
// Config:
exports.GET_CONFIG = "".concat(exports.ROOT, "/config/get-config");
exports.PUBLISH_CONFIG = "".concat(exports.ROOT, "/config/publish-config");
// Website:
exports.PUBLIC_SUBMISSIONS_PAGINATE = "".concat(exports.ROOT, "/public/submissions/paginate");
exports.PUBLIC_SUBMISSIONS_GET = "".concat(exports.ROOT, "/public/submissions/:id");
exports.PUBLIC_SUBMISSIONS_AGGREGATE = "".concat(exports.ROOT, "/public/submissions/aggregate");
exports.PUBLIC_EMAIL_SEND = "".concat(exports.ROOT, "/public/email");
//# sourceMappingURL=routes.js.map